import { createContext } from "react";

import { DetailedPaymentMethod } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/admin/v1/payment_method_pb";
import {
  CreditCardDetails,
  PayPalAccountDetails,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/payment_method_pb";

export type PaymentMethodsContextType = {
  paymentMethods: DetailedPaymentMethod[];
  setPaymentMethods: React.Dispatch<
    React.SetStateAction<DetailedPaymentMethod[]>
  >;
  isPaymentMethodsLoading: boolean;
  setIsPaymentMethodsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  defaultPaymentMethod: DetailedPaymentMethod | undefined;
  setDefaultPaymentMethod: React.Dispatch<
    React.SetStateAction<DetailedPaymentMethod | undefined>
  >;
  defaultPaymentMethodDetails:
    | CreditCardDetails
    | PayPalAccountDetails
    | undefined;
  setDefaultPaymentMethodDetails: React.Dispatch<
    CreditCardDetails | PayPalAccountDetails | undefined
  >;
};

export const PaymentMethodsContext = createContext<PaymentMethodsContextType>(
  {} as PaymentMethodsContextType
);
